import { GET_DMX_DEVICE_PRESETS, GET_DMX_DEVICE_PRESETS_SUCCESS, GET_DMX_DEVICE_PRESETS_ERROR } from './actionTypes';

const initialState = {
  errorGetDmxDevicePresets: '',
  loadingGetDmxDevicePresets: false,
  presets: null,
};

const getDevicePresets = (state = initialState, action) => {
  switch (action.type) {
    case GET_DMX_DEVICE_PRESETS:
      state = { ...state, loadingGetDmxDevicePresets: true };
      break;
    case GET_DMX_DEVICE_PRESETS_SUCCESS:
      state = { ...state, loadingGetDmxDevicePresets: false, presets: action.payload.presets };
      break;
    case GET_DMX_DEVICE_PRESETS_ERROR:
      state = { ...state, errorGetDmxDevicePresets: action.payload, loadingGetDmxDevicePresets: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getDevicePresets;
